const bgGradientStops = {
  '--io-bg-radial-1': [[255, 92, 0, 0.58], [255, 255, 255, 0.7]],
  '--io-bg-radial-2': [[255, 132, 16, 0.36], [255, 255, 255, 0.7]],
  '--io-bg-radial-3': [[255, 178, 54, 0.16], [255, 255, 255, 0.7]],
  '--io-bg-linear-1': [[255, 86, 0, 0.36], [255, 255, 255, 0.7]],
  '--io-bg-linear-2': [[255, 122, 18, 0.22], [255, 255, 255, 0.7]],
  '--io-bg-linear-3': [[255, 166, 44, 0.105], [255, 255, 255, 0.7]]
};

let lastGradientStep = -1;

const updateBackgroundGradient = () => {
  if (document.documentElement.classList.contains('io-motion-limited')) return;

  if (lastGradientStep === 0) return;
  lastGradientStep = 0;

  Object.keys(bgGradientStops).forEach((name) => {
    document.body.style.removeProperty(name);
  });
};

let scrollFrame = 0;
let lastVignetteOpacity = null;

const syncScrollEffects = () => {
  scrollFrame = 0;

  const scrollPosition = window.scrollY || window.pageYOffset;
  const windowHeight = window.innerHeight;
  const opacity = Math.max(1 - (scrollPosition / (windowHeight * 0.5)), 0).toFixed(3);

  if (opacity !== lastVignetteOpacity) {
    lastVignetteOpacity = opacity;
    document.body.style.setProperty('--vignette-opacity', opacity);
  }

  updateBackgroundGradient(scrollPosition);
};

document.addEventListener('scroll', () => {
  if (scrollFrame) return;
  scrollFrame = window.requestAnimationFrame(syncScrollEffects);
}, { passive: true });

updateBackgroundGradient();
syncScrollEffects();

// Use event delegation for card click handling
document.addEventListener('click', function(e) {
  const cardWrapper = e.target.closest('.card-wrapper');
  if (cardWrapper && cardWrapper.href) {
    e.preventDefault();
    setTimeout(() => {
      window.location = cardWrapper.href;
    }, 150); // Matches our animation duration
  }
});
